import { Component, OnInit } from '@angular/core';
import {PublicService} from '../public.service';
import { FormControl, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';


@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  constructor(public publicservice : PublicService, public router: Router) { }

  ngOnInit(): void {
  }

  backhome() {
    this.router.navigate(['home']);
  }

}
